import type { GetOfferRequest, GetOfferResponse, Item } from '@numa-group/checkout-api';
import { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import type { SiteLocale } from '@src/generated/dato-cms';
import type { ApiResponse } from '@src/types/api/response/api-response';

export class CartItemService {
  constructor(
    protected networkService: AxiosInstance,
    private authService: IAuthService,
  ) {}

  async getCartItem<T extends Item = Item>(request: GetOfferRequest, locale: SiteLocale) {
    const apiToken = await this.authService.getAuthToken();

    const response = await this.networkService.post<ApiResponse<GetOfferResponse<T>>>(
      `item-offers?locale=${locale}`,
      request,
      { headers: { ...(apiToken && { Authorization: `Bearer ${apiToken}` }) } },
    );

    return response.data.data;
  }
}
